module.exports = __webpack_public_path__ + "media/images/pic/brodno/teddy-eddie-285fdd095edff7355b5990c6dab52911.png";